angular.module('FlexyBeautyApp')
    .factory('Images', [
    function() {
        return {
            saleStatus: {
                advance: '/img/svg/salestatussvg/advance.svg',
                created: '/img/svg/salestatussvg/created.svg',
                paid: '/img/svg/salestatussvg/paid.svg',
                waiting: '/img/svg/salestatussvg/waiting.svg',
            }
        }
    }
]);



// WEBPACK FOOTER //
// ./js/constants/Images.js